export const levels = ['Beginner', 'Elementary', 'Intermediate', 'Advanced', 'Fluent/Native'];
